import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import SummaryApi from "../common";
import { FaCheckCircle, FaSpinner } from "react-icons/fa";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../helpers/AuthContext";

const StudentCourseCurriculum = () => {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [curriculum, setCurriculum] = useState([]);
  const [lessonsByCurriculum, setLessonsByCurriculum] = useState({});
  const [closedLessons, setClosedLessons] = useState([]);
  const [closedTopics, setClosedTopics] = useState([]);
  const [openCurriculumId, setOpenCurriculumId] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [timeSlotDetails, setTimeSlotDetails] = useState(null);
  const [todayClassInfo, setTodayClassInfo] = useState(null);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);
  const [selectedAssignmentResult, setSelectedAssignmentResult] = useState(null);
  const studentId = Number(localStorage.getItem("student_id"));
  const [currentTime, setCurrentTime] = useState(new Date());
const [assignmentResults, setAssignmentResults] = useState([]);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const encodedTimeSlotId = queryParams.get("time_slot_id");

  const courseId = parseInt(atob(id));
  const [dynamicTimeSlotId, setDynamicTimeSlotId] = useState(
    encodedTimeSlotId ? parseInt(atob(encodedTimeSlotId)) : null
  );

  const { studentEmail } = useAuth();

  const calculateDaysLeft = () => {
    if (!timeSlotDetails || !timeSlotDetails.end_date) return null;
    const endDate = new Date(timeSlotDetails.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const timeDiff = endDate.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return daysLeft > 0 ? daysLeft : 0;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const CourseDescription = ({ text = "", maxChars = 150 }) => {
    const [expanded, setExpanded] = useState(false);
    if (text.length <= maxChars) {
      return <p className="text-gray-700 dark:text-gray-300 transition-colors">{text}</p>;
    }
    return (
      <p className="text-gray-700 dark:text-gray-300 transition-colors">
        {expanded ? text : `${text.substring(0, maxChars)}... `}
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-blue-600 dark:text-blue-400 font-medium ml-1 hover:underline transition-colors"
        >
          {expanded ? "Show less" : "Read more"}
        </button>
      </p>
    );
  };

  useEffect(() => {
  const timer = setInterval(() => {
    setCurrentTime(new Date());
  }, 1000); // Update every second
  
  return () => clearInterval(timer); // Cleanup on unmount
}, []);
  useEffect(() => {
    if (!courseId) return;
    fetch(SummaryApi.coursedetailsById.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ course_id: courseId }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) setCourse(data.data);
      })
      .catch((err) => console.error("Failed to fetch course:", err));
  }, [courseId]);

  useEffect(() => {
    if (!courseId) return;
    setLoading(true);
    fetch(SummaryApi.getCurriculumByCourseId.url, {
      method: SummaryApi.getCurriculumByCourseId.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ course_id: Number(courseId) }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setCurriculum(data.data);
          if (data.data.length > 0) {
            setOpenCurriculumId(data.data[0].curriculum_id);
          }
        }
      })
      .catch((err) => console.error("Failed to fetch curriculum:", err));
  }, [courseId]);

  useEffect(() => {
    if (!courseId || !dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId))) return;
    setLoading(true);
    Promise.allSettled([
      fetch(SummaryApi.basedontimeslotlessonclosed.url, {
        method: SummaryApi.basedontimeslotlessonclosed.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          course_id: Number(courseId),
          time_slot_id: Number(dynamicTimeSlotId),
        }),
      }).then((res) => res.json()),
      fetch(SummaryApi.gettopicclosed.url, {
        method: SummaryApi.gettopicclosed.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          course_id: Number(courseId),
          time_slot_id: Number(dynamicTimeSlotId),
        }),
      }).then((res) => res.json()),
    ])
      .then(([lessonsResult, topicsResult]) => {
        if (lessonsResult.status === "fulfilled") {
          const data = lessonsResult.value;
          setClosedLessons(
            data.status
              ? (data.data || []).filter((item) => item && item.lesson_id !== undefined)
              : []
          );
        }
        if (topicsResult.status === "fulfilled") {
          const data = topicsResult.value;
          setClosedTopics(
            data.status
              ? (data.data || []).filter((item) => item && item.curriculum_id !== undefined)
              : []
          );
        }
      })
      .finally(() => setLoading(false));
  }, [courseId, dynamicTimeSlotId]);
const isAssignmentCompleted = (assignmentId) => {
  return assignmentResults.some(result => result.assignment_id === assignmentId);
};

const getAssignmentResult = (assignmentId) => {
  return assignmentResults.find(result => 
    result.assignment_id === assignmentId && result.result_id > 0
  );
};
  const fetchLessons = async () => {
    if (curriculum.length === 0 || !dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId))) {
      setLessonsByCurriculum({});
      setLoading(false);
      return;
    }
    const lessonsMap = {};
    for (const topic of curriculum) {
      try {
        const response = await fetch(SummaryApi.getCourseLessonByCurriculumId.url, {
          method: SummaryApi.getCourseLessonByCurriculumId.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ curriculum_id: topic.curriculum_id }),
        });
        const data = await response.json();
        lessonsMap[topic.curriculum_id] =
          data.status && Array.isArray(data.data)
            ? data.data.map((lesson) => {
                const isLessonClosed = closedLessons.some(
                  (closed) =>
                    closed.lesson_id === lesson.lesson_id &&
                    closed.curriculum_id === lesson.curriculum_id &&
                    closed.time_slot_id === Number(dynamicTimeSlotId) &&
                    closed.course_id === lesson.course_id &&
                    closed.is_active === 1
                );
                return { ...lesson, completed: isLessonClosed };
              })
            : [];
      } catch (error) {
        lessonsMap[topic.curriculum_id] = [];
      }
    }
    setLessonsByCurriculum(lessonsMap);
    setLoading(false);
  };

  useEffect(() => {
    fetchLessons();
  }, [curriculum, closedLessons, dynamicTimeSlotId]);

useEffect(() => {
  if (!studentId || !lessonsByCurriculum || Object.keys(lessonsByCurriculum).length === 0) return;

  const fetchAssignmentResultsForLessons = async () => {
    try {
      // Get all unique assignment_ids from all lessons
      const allAssignmentIds = [];
      Object.values(lessonsByCurriculum).forEach(lessons => {
        lessons.forEach(lesson => {
          if (lesson.assignment_id > 0 && !allAssignmentIds.includes(lesson.assignment_id)) {
            allAssignmentIds.push(lesson.assignment_id);
          }
        });
      });

      // Fetch results for each assignment
      const results = [];
      for (const assignmentId of allAssignmentIds) {
        try {
          const response = await fetch(SummaryApi.result_by_student_assignment.url, {
            method: SummaryApi.result_by_student_assignment.method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              assignment_id: assignmentId,
              student_id: studentId,
            }),
          });
          const data = await response.json();
          
          if (data.status && data.data) {
            // Check if it's an array or single object
            let resultData;
            if (Array.isArray(data.data)) {
              // Filter results where result_id > 0
              resultData = data.data.find(item => item.result_id > 0);
            } else {
              // Single object, check if result_id > 0
              resultData = data.data.result_id > 0 ? data.data : null;
            }
            
            if (resultData) {
              results.push({
                assignment_id: assignmentId,
                ...resultData
              });
            }
          }
        } catch (error) {
          console.error(`Error fetching result for assignment ${assignmentId}:`, error);
        }
      }
      setAssignmentResults(results);
    } catch (error) {
      console.error("Failed to fetch assignment results:", error);
    }
  };

  fetchAssignmentResultsForLessons();
}, [lessonsByCurriculum, studentId]);

const getRemainingTime = (cls) => {
  if (!cls?.time_slot || cls.time_slot === "N/A") return null;

  const { endTime } = extractTimeFromRange(cls.time_slot);
  if (!endTime) return null;

  const today = currentTime.toISOString().split("T")[0];
  const classEnd = new Date(`${today}T${endTime}`);

  if (currentTime >= classEnd) return null;

  const remainingMs = classEnd - currentTime;
  const hours = Math.floor(remainingMs / (1000 * 60 * 60));
  const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remainingMs % (1000 * 60)) / 1000);

  // Format with seconds that will count down
  if (hours > 0) {
    return `${hours}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s remaining`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds.toString().padStart(2, '0')}s remaining`;
  } else {
    return `${seconds}s remaining`;
  }
};


  const calculateTotalDuration = (lessons) => {
    if (!lessons || !Array.isArray(lessons)) return "0 min";
    const totalMinutes = lessons.reduce((total, lesson) => {
      if (!lesson.duration) return total;
      let minutes = 0;
      if (typeof lesson.duration === "number") {
        minutes = lesson.duration;
      } else if (typeof lesson.duration === "string") {
        if (lesson.duration.includes("hour")) {
          minutes = (parseInt(lesson.duration) || 0) * 60;
        } else if (lesson.duration.includes("h")) {
          const [hours, mins] = lesson.duration.split("h").map((part) => {
            const num = parseInt(part.replace(/[^\d]/g, ""));
            return isNaN(num) ? 0 : num;
          });
          minutes = hours * 60 + (mins || 0);
        } else {
          minutes = parseInt(lesson.duration) || 0;
        }
      }
      return total + minutes;
    }, 0);

    if (totalMinutes < 60) return `${totalMinutes} min`;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours} hour${hours > 1 ? "s" : ""}`;
  };

  const handleAssignmentClick = (assignmentId, completed) => {
    navigate(
      `/student-panel/assignment-student/${assignmentId}?course_id=${courseId}&time_slot_id=${dynamicTimeSlotId}&completed=${completed}`
    );
  };
const handleViewAssignmentDetails = async (assignmentId) => {
  const result = getAssignmentResult(assignmentId);
  if (result) {
    setSelectedAssignmentResult(result);
    
    // Fetch assignment details to get the name and number of questions
    try {
      const response = await fetch(SummaryApi.assignment_by_id_retrieve_by_id.url, {
        method: SummaryApi.assignment_by_id_retrieve_by_id.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ assignment_id: assignmentId }),
      });
      const data = await response.json();
      if (data.status && data.data) {
        // Also fetch student's answer details to get attempted questions count
        const answersResponse = await fetch(SummaryApi.student_assignment_answers.url, {
          method: SummaryApi.student_assignment_answers.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            assignment_id: assignmentId,
            student_id: studentId 
          }),
        });
        const answersData = await answersResponse.json();
        
        // Calculate attempted questions
        let attemptedQuestions = 0;
        if (answersData.status && Array.isArray(answersData.data)) {
          attemptedQuestions = answersData.data.filter(answer => 
            answer.selected_option !== null && answer.selected_option !== ""
          ).length;
        }
        
        setSelectedAssignmentResult({
          ...result,
          assignment_name: data.data.assignment_name,
          number_of_questions: data.data.number_of_questions,
          total_marks: data.data.total_marks || 0,
          attempted_questions: attemptedQuestions
        });
      } else {
        // If fetching fails, at least show the result without the name
        setSelectedAssignmentResult(result);
      }
    } catch (error) {
      console.error("Failed to fetch assignment details:", error);
      setSelectedAssignmentResult(result);
    }
    
    setShowAssignmentModal(true);
  } else {
    toast.error("No results found for this assignment");
  }
};

  const toggleCurriculum = (id) => {
    setOpenCurriculumId((prev) => (prev === id ? null : id));
  };

  const formatDuration = (duration) => {
    if (!duration) return "";
    if (typeof duration === "string" && (duration.includes("min") || duration.includes("hour"))) {
      return duration;
    }
    const minutes = parseInt(duration);
    if (!isNaN(minutes)) {
      if (minutes < 60) return `${minutes} min`;
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours} hour${hours > 1 ? "s" : ""}`;
    }
    return duration;
  };

  // useEffect(() => {
  //   if (!dynamicTimeSlotId || !courseId || !studentId) return;
  //   const fetchTodayClass = async () => {
  //     try {
  //       const res = await fetch(SummaryApi.studentTimeslotByandtimeslotid.url, {
  //         method: SummaryApi.studentTimeslotByandtimeslotid.method,
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ time_slot_id: Number(dynamicTimeSlotId)}),
  //       });
  //       const data = await res.json();
  //       if (data.status && Array.isArray(data.data)) {
  //         const dayOfWeek = new Date().toLocaleString("en-US", { weekday: "long" }).toLowerCase();
  //         const todayClasses = data.data
  //           .filter((cls) => cls.course_id === courseId && cls.time_slot_id === dynamicTimeSlotId)
  //           .map((cls) => ({ ...cls, time_slot: cls[dayOfWeek] || "N/A" }))
  //           .filter((cls) => cls.time_slot !== "N/A");
  //         if (todayClasses.length > 0) {
  //           setTodayClassInfo(todayClasses[0]);
  //         } else if (timeSlotDetails?.start_date) {
  //           const startDate = new Date(timeSlotDetails.start_date);
  //           const today = new Date();
  //           today.setHours(0, 0, 0, 0);
  //           if (startDate > today) {
  //             setTodayClassInfo({ isUpcoming: true, start_date: timeSlotDetails.start_date });
  //           } else {
  //             setTodayClassInfo(null);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       setTodayClassInfo(null);
  //     }
  //   };
  //   fetchTodayClass();
  // }, [dynamicTimeSlotId, courseId, studentId, timeSlotDetails]);
useEffect(() => {
  if (!dynamicTimeSlotId || !courseId) return;

  const fetchTodayClass = async () => {
    try {
      const res = await fetch(SummaryApi.studentTimeslotByandtimeslotid.url, {
        method: SummaryApi.studentTimeslotByandtimeslotid.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ time_slot_id: Number(dynamicTimeSlotId) }),
      });

      const data = await res.json();
      if (!data.status || !Array.isArray(data.data)) {
        setTodayClassInfo(null);
        return;
      }

      const slot = data.data[0]; // You only have one per ID

      const today = new Date()
        .toLocaleDateString("en-US", { weekday: "long" })
        .toLowerCase(); // <-- MATCH API KEY

      const todaysTimeRange = slot[today]; // e.g. slot["wednesday"]

      if (todaysTimeRange && todaysTimeRange !== "N/A") {
        setTodayClassInfo({
          ...slot,
          time_slot: todaysTimeRange,    // Important!!
          isUpcoming: false,
        });
      } else {
        // no class today → still show disabled button
        setTodayClassInfo({
          ...slot,
          time_slot: "N/A",
          isUpcoming: false,
        });
      }
    } catch (err) {
      console.error("Fetch today class failed:", err);
      setTodayClassInfo(null);
    }
  };

  fetchTodayClass();
}, [dynamicTimeSlotId, courseId]);


  const joinTodayClass = () => {
    window.open("https://meet.google.com", "_blank", "noopener,noreferrer");
  };

  const extractTimeFromRange = (timeRange) => {
    if (!timeRange || timeRange === "N/A") return { startTime: null, endTime: null };
    try {
      const [start, end] = timeRange.split("-");
      const startTime = start.trim().slice(0, 5) + ":00";
      const endTime = end.trim().slice(0, 5) + ":00";
      return { startTime, endTime };
    } catch {
      return { startTime: null, endTime: null };
    }
  };

const isClassOngoing = (cls) => {
  if (!cls?.time_slot || cls.time_slot === "N/A") return false;
  const { startTime, endTime } = extractTimeFromRange(cls.time_slot);
  if (!startTime || !endTime) return false;
  
  const today = currentTime.toISOString().split("T")[0];
  const start = new Date(`${today}T${startTime}`);
  const end = new Date(`${today}T${endTime}`);
  
  return currentTime >= start && currentTime < end;
};

  const formatTimeRange = (cls) => {
    const { startTime, endTime } = extractTimeFromRange(cls.time_slot);
    if (!startTime || !endTime) return "N/A";
    const to12Hr = (t) => {
      const [h, m] = t.split(":").map(Number);
      const period = h >= 12 ? "PM" : "AM";
      const hh = h % 12 || 12;
      return `${hh}:${m.toString().padStart(2, "0")} ${period}`;
    };
    return `${to12Hr(startTime)} - ${to12Hr(endTime)}`;
  };

  if (loading || !course) return <p className="p-8 text-gray-700 dark:text-gray-300">Loading course...</p>;

  return (
    <div
      className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300"
      style={{
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      }}
    >
<div className="flex justify-end w-full px-4 sm:px-6 pt-4">
  {/* Show remaining time ONLY when class is ongoing */}
  {isClassOngoing(todayClassInfo) && (
    <div className="flex items-center gap-2 mr-3">
      <span className="text-green-600 font-semibold">
        Session ends in {getRemainingTime(todayClassInfo)}
      </span>
    </div>
  )}
  
  <button
    onClick={isClassOngoing(todayClassInfo) ? joinTodayClass : undefined}
    disabled={!isClassOngoing(todayClassInfo)}
    className={`px-6 py-1 rounded-md text-base font-semibold transition shadow-sm ${
      isClassOngoing(todayClassInfo)
        ? "bg-green-600 dark:bg-green-700 text-white hover:bg-green-700 dark:hover:bg-green-600 cursor-pointer"
        : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
    }`}
  >
    {isClassOngoing(todayClassInfo) ? (
      <span className="flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
        </span>
        Join Class
      </span>
    ) : (
      "Join Class"
    )}
  </button>
</div>
      <div className="overflow-hidden">
        {/* Course Info Header */}
        <div className="p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 bg-gradient-to-r from-teal-50 to-white dark:from-gray-800 dark:to-gray-900 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 transition-colors duration-300">
            {/* Left Section */}
            <div className="mb-3 sm:mb-0">
   <div className="flex flex-wrap items-center gap-3">
  <h1 className="text-2xl sm:text-3xl font-bold capitalize text-gray-800 dark:text-gray-100 tracking-wide">
    {course?.course_title || "Course"} Curriculum
  </h1>

  {/* Course Completed Badge - Perfectly in row */}
  {timeSlotDetails?.is_course_completed === 1 && (
    <div className="flex items-center">
      <span className="inline-flex items-center gap-2 rounded-full bg-emerald-100 dark:bg-emerald-900/50 px-4 py-1 text-sm font-bold text-emerald-800 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700 shadow-lg animate-in fade-in slide-in-from-left duration-500">
        <FaCheckCircle className="w-5 h-5" />
        Course Completed
      </span>
    </div>
  )}
</div>
              {timeSlotDetails && (
                <p className="text-gray-600 dark:text-gray-400 text-sm mt-1">
                  ({formatDate(timeSlotDetails.start_date)} - {formatDate(timeSlotDetails.end_date)})
                </p>
              )}
            </div>

            {/* Right Section */}
            <div className="text-right">
              <div className="text-sm sm:text-base text-gray-700 dark:text-gray-300 font-medium">
                {curriculum.length} {curriculum.length === 1 ? "Topic" : "Topics"} |{" "}
                {Object.values(lessonsByCurriculum).reduce((total, lessons) => total + lessons.length, 0)}{" "}
                {Object.values(lessonsByCurriculum).reduce((total, lessons) => total + lessons.length, 0) === 1
                  ? "Lesson"
                  : "Lessons"}
              </div>

              {calculateDaysLeft() !== null && (
                <div
                  className={`text-sm sm:text-base font-semibold mt-2 transition-all duration-300 ${
                    calculateDaysLeft() <= 7 && calculateDaysLeft() > 0
                      ? "text-orange-600 dark:text-orange-400"
                      : "text-green-600 dark:text-green-400"
                  }`}
                >
                  {calculateDaysLeft() > 7
                    ? `${calculateDaysLeft()} day${calculateDaysLeft() > 1 ? "s" : ""} left`
                    : calculateDaysLeft() === 7
                    ? "1 week left"
                    : calculateDaysLeft() > 0
                    ? `${calculateDaysLeft()} day${calculateDaysLeft() > 1 ? "s" : ""} left`
                    : "Course ended"}
                </div>
              )}
            </div>
          </div>

          <div className="w-full overflow-hidden rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
            <img
              src={
                course?.course_image2
                  ? `${SummaryApi.Images?.url?.replace("api", "")}${course.course_image2}`
                  : "https://via.placeholder.com/1200x400/1f4774/ffffff?text=Course+Image"
              }
              alt={course?.course_title || "Course Banner"}
              className="w-full h-64 sm:h-96 md:h-[28rem] object-cover"
            />
          </div>

          <div className="mt-4 px-4 sm:px-6 md:px-8 w-full mb-4">
            <div className="flex justify-end">
              <button
                onClick={() => setShowDetails(!showDetails)}
                className="text-[#1C3664] dark:text-blue-400 font-medium hover:underline transition-colors"
              >
                {showDetails ? "Hide Details" : "View Details"}
              </button>
            </div>

            {showDetails && (
              <div className="mt-4 w-full border border-gray-300 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-800 shadow-sm p-6 transition-all duration-300">
                <p className="text-gray-800 dark:text-gray-100 font-semibold text-lg mb-3">
                  {course?.subtitle || "Course Description"}
                </p>
                <div className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4">
                  <CourseDescription text={course?.short_desc || "No description available"} maxChars={200} />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-3 gap-x-6 text-sm text-gray-700 dark:text-gray-300 font-medium">
                  <div className="flex items-center gap-2">
                    <span className="text-gray-500 dark:text-gray-400">Duration:</span>
                    <span>{course?.course_duration || "N/A"}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-500 dark:text-gray-400">Difficulty:</span>
                    <span>{course?.diffculty_level || "N/A"}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-500 dark:text-gray-400">Language:</span>
                    <span>{course?.language_instruction || "N/A"}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-500 dark:text-gray-400">Rating:</span>
                    <span>{course?.rating || "N/A"} ⭐</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Curriculum Sections */}
          <div className="space-y-5">
            {curriculum.map(({ curriculum_id, topic_name }) => {
              const isOpen = openCurriculumId === curriculum_id;
              const lessonCount = lessonsByCurriculum[curriculum_id]?.length || 0;
              const totalDuration = calculateTotalDuration(lessonsByCurriculum[curriculum_id]);
              const isTopicClosed = closedTopics.some(
                (topic) =>
                  topic.curriculum_id === curriculum_id &&
                  topic.time_slot_id === Number(dynamicTimeSlotId) &&
                  topic.course_id === Number(courseId) &&
                  topic.is_closed === 1
              );

              return (
                <div
                  key={curriculum_id}
                  className="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm transition-all duration-200 hover:shadow-md dark:hover:border-gray-600"
                >
                  <button
                    onClick={() => toggleCurriculum(curriculum_id)}
                    className={`w-full px-5 py-4 text-left transition-all duration-200 sm:px-6 sm:py-5 flex items-center justify-between ${
                      isOpen
                        ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white"
                        : "bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700"
                    }`}
                  >
                    <div className="flex-1 text-left">
                      <h3 className={`font-semibold sm:text-lg ${isOpen ? "text-white" : "text-gray-900 dark:text-gray-100"}`}>
                        {topic_name.trim()}
                        {isTopicClosed && (
                          <span className="ml-2 text-[10px] bg-green-600 text-white px-1 py-0.5 rounded-full shadow-sm">
                            Completed
                          </span>
                        )}
                      </h3>
                      <div className={`mt-1 flex items-center gap-4 text-sm ${isOpen ? "text-blue-100" : "text-gray-500 dark:text-gray-400"}`}>
                        <div className="flex items-center gap-2">
                          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                          </svg>
                          <span>{lessonCount} lesson{lessonCount !== 1 ? "s" : ""}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                          </svg>
                          <span>{totalDuration}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors ml-4 ${
                        isOpen
                          ? "bg-white text-blue-600"
                          : "bg-blue-100 dark:bg-gray-700 text-blue-600 dark:text-blue-400"
                      }`}
                    >
                      {isOpen ? <FiChevronDown className="h-5 w-5" /> : <FiChevronRight className="h-5 w-5" />}
                    </div>
                  </button>

                  {isOpen && (
                    <div className="border-t border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800">
                      {lessonCount > 0 ? (
                        <div className="relative">
                          {/* Timeline Line */}
                          <div className="absolute left-9 top-0 bottom-0 w-0.5 bg-gray-200 dark:bg-gray-700 sm:left-10"></div>
                          <div className="divide-y divide-gray-100 dark:divide-gray-700">
                            {lessonsByCurriculum[curriculum_id].map((lesson, index) => (
                              <div key={lesson.lesson_id} className="relative px-4 py-3 transition-all duration-200 sm:px-6 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                {/* Status Circle */}
                                <div
                                  className={`absolute left-8 top-5 -translate-x-1/2 z-10 flex h-4 w-4 items-center justify-center rounded-full border-2 sm:left-10 ${
                                    lesson.completed
                                      ? "border-green-600 bg-green-600 shadow-sm"
                                      : "border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-sm"
                                  }`}
                                >
                                  {lesson.completed && (
                                    <svg className="h-2.5 w-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                  )}
                                </div>

                                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between pl-1">
                                  <div className="flex items-start gap-3">
                                    <div className="flex-1 pl-4 sm:pl-6">
                                      <div className="flex items-center gap-2">
                                        <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100">
                                          {lesson.lesson_name}
                                        </h4>
                                        {lesson.completed && (
                                          <span className="inline-flex items-center gap-1 rounded-full bg-green-100 dark:bg-green-900/30 px-2 py-0.5 text-sm font-medium text-green-800 dark:text-green-300 border border-green-200 dark:border-transparent">
                                            Completed
                                          </span>
                                        )}
                                      </div>
                                      {!lesson.completed && lesson.progress > 0 && (
                                        <div className="mt-1 flex justify-start">
                                          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-50 dark:bg-yellow-900/30 px-2.5 py-1 text-[11px] font-medium text-yellow-700 dark:text-yellow-300 border border-yellow-200 dark:border-transparent">
                                            <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                                              <path d="M10 2a8 8 0 100 16 8 8 0 000-16zm0 14a6 6 0 110-12 6 6 0 010 12z" />
                                              <path d="M10 5a5 5 0 015 5H10V5z" />
                                            </svg>
                                            {lesson.progress}% Complete
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2 pl-4 sm:pl-0 sm:justify-end">
                                    {lesson.duration && (
                                      <div className="flex items-center justify-center">
                                        <span
                                          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium border ${
                                            lesson.completed
                                              ? "text-green-700 dark:text-green-400 border-transparent"
                                              : "bg-gray-50 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-100 dark:border-gray-600"
                                          }`}
                                        >
                                          <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                          </svg>
                                          {formatDuration(lesson.duration)}
                                        </span>
                                      </div>
                                    )}
{lesson.assignment_id > 0 ? (
  isAssignmentCompleted(lesson.assignment_id) ? (
    <button
      onClick={() => handleViewAssignmentDetails(lesson.assignment_id)}
      className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1 text-sm font-medium transition-all duration-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 hover:bg-green-100 dark:hover:bg-green-900/50 focus:ring-green-500 border border-green-100 dark:border-transparent"
    >
      View Results
    </button>
  ) : (
    <button
      onClick={() => handleAssignmentClick(lesson.assignment_id, false)}
      className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1 text-sm font-medium transition-all duration-200 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/50 focus:ring-blue-500 border border-blue-100 dark:border-transparent"
    >
      <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 3C5 3 1.73 7.11 1.73 10s3.27 7 8.27 7 8.27-4.11 8.27-7-3.27-7-8.27-7zm0 12a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z" />
      </svg>
      Start Assignment
    </button>
  )
) : null}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="px-6 py-12 text-center bg-white dark:bg-gray-800 transition-colors">
                          <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500">
                            <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                          </div>
                          <h4 className="mb-1 text-lg font-semibold text-gray-900 dark:text-gray-100">
                            No lessons available yet
                          </h4>
                          <p className="text-gray-500 dark:text-gray-400 max-w-sm mx-auto text-sm">
                            We're preparing high-quality content for this topic. Check back soon!
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

{showAssignmentModal && selectedAssignmentResult && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
    {/* Click outside to close */}
    <div
      className="absolute inset-0"
      onClick={() => setShowAssignmentModal(false)}
    />

    <div className="relative w-full max-w-lg overflow-hidden rounded-2xl bg-white dark:bg-gray-800 shadow-2xl border border-gray-200 dark:border-gray-700">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-emerald-600 px-6 py-4 text-white">
        <h2 className="text-xl font-bold text-center">Assignment Results</h2>
      </div>

      {/* Body */}
      <div className="p-6 space-y-5">
        {/* Assignment Details */}
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Test:</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">
              {selectedAssignmentResult.assignment_name || "N/A"}
            </span>
          </div>
          
          {/* Number of Questions */}
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Number of Questions:</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">
              {selectedAssignmentResult.number_of_questions || "N/A"}
            </span>
          </div>

          {/* Pass Marks */}
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Marks:</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">
              {selectedAssignmentResult.pass_marks || "N/A"} / {selectedAssignmentResult.total_marks || "N/A"}
            </span>
          </div>


          {/* Submitted Date */}
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Submitted Date:</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">
              {formatDate(selectedAssignmentResult.result_created_date)}
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 pb-6 flex justify-center">
        <button
          onClick={() => setShowAssignmentModal(false)}
          className="px-8 py-3 bg-gray-800 hover:bg-gray-900 dark:bg-gray-700 dark:hover:bg-gray-600 text-white font-medium rounded-xl transition-all duration-200 hover:shadow-lg"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default StudentCourseCurriculum;